// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3YQxO","left":"Header_left__13aRZ","right":"Header_right__2puEy","middle":"Header_middle__HAKw4"};